export const nav = [
  {
    name: "Home",
    component: "home",
    icon: "fas fa-home",
    tagline: "is where we all want to be"
  },
  {
    name: "Work",
    component: "work",
    icon: "fas fa-suitcase",
    tagline: "puts my skills to test"
  },
  // {
  //   name: "Blogs",
  //   component: "blogs",
  //   icon: "fab fa-pagelines",
  //   tagline: "is where you see my creative side"
  // },
  {
    name: "About",
    component: "about",
    icon: "fas fa-user-tie",
    tagline: "to know me better as a professional"
  },
  {
    name: "Contact",
    component: "contact",
    icon: "far fa-id-badge",
    tagline: "will help you get in touch with me"
  }
];
